export default __webpack_public_path__ + "static/pregunta-5-02611527c3bc64a1918630e74f593422.png";